import { Controller } from 'stimulus';

// The Allowed Tasks tab on a job template (Jobs::AllowedTasksController).
// Shortlist toggles, seed, and clear post asynchronously; the server
// responds with the re-rendered content block, and the filter query is
// re-applied after each swap so mid-filter edits don't lose their place.
export default class extends Controller {
  static targets = ['content', 'query'];

  post(event) {
    this.request(event.currentTarget.dataset.url);
  }

  clear(event) {
    if (!window.confirm('Clear the whole shortlist? The picker goes back to showing everything.')) return;
    this.request(event.currentTarget.dataset.url, 'DELETE');
  }

  filter() {
    const query = (this.hasQueryTarget ? this.queryTarget.value : '').trim().toLowerCase();
    this.element.querySelectorAll('[data-filter-row]').forEach(row => {
      row.style.display = row.dataset.filterWith.indexOf(query) >= 0 ? '' : 'none';
    });
  }

  request(url, method) {
    const query = this.hasQueryTarget ? this.queryTarget.value : '';
    fetch(url, {
      method: method || 'POST',
      credentials: 'same-origin',
      headers: {
        'X-CSRF-Token': (document.querySelector('meta[name="csrf-token"]') || {}).content,
        'Accept': 'application/json'
      }
    })
      .then(response => (response.ok ? response.json() : Promise.reject(response)))
      .then(json => {
        this.contentTarget.innerHTML = json.content;
        if (this.hasQueryTarget && query) {
          this.queryTarget.value = query;
          this.filter();
        }
      })
      .catch(() => window.location.reload());
  }
}
